import React from 'react';
import classNames from 'classnames';

const BootstrapSpinner = ({
  className,
  animation = 'border',
  role = 'status',
  size,
  style,
  children,
}) => {
  const spinnerClass = animation === 'grow' ? 'spinner-grow' : 'spinner-border';
  const sizeClass = size === 'sm' ? `${spinnerClass}-sm` : '';

  return (
    <div
      className={classNames(spinnerClass, sizeClass, className)}
      role={role}
      style={style}
    >
      {children || <span className="sr-only">Loading...</span>}
    </div>
  );
};

export default BootstrapSpinner;